import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const HeaderWrapper = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  }
}));

export const IntegrationSelectWrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    width: '300px'
  }
}));

export const LogoWrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  textAlign: 'center',
  marginTop: theme.spacing(3),
  [theme.breakpoints.up('sm')]: {
    width: '200px',
    alignSelf: 'flex-end',
    marginTop: 0
  }
}));

export const LabelWrapper = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 600,
  fontSize: '16px'
}));
